import { useEffect, useState } from 'react';
import useResize from './useResize';

export interface ResponsiveResizeDimensions {
  innerWidth: number;
  innerHeight: number;
}

const useResizeResponsive = (
  comparator: (dimensions: ResponsiveResizeDimensions) => boolean
) => {
  const [result, setResult] = useState(false);

  const resize = useResize();

  const { innerWidth, innerHeight } = resize;

  useEffect(() => {
    const comparatorResult = comparator({
      innerWidth,
      innerHeight,
    });

    if (comparatorResult !== result) {
      setResult(comparatorResult);
    }
  }, [result, innerWidth, innerHeight, comparator]);

  return result;
};

export default useResizeResponsive;
